import { useEffect, useState } from 'react';
import { fetchPlaygroundAccess } from '../api/playground';
import { readOidcSub } from '../api/applicationTemplates';
import { useAuthContext } from '../providers/AuthProvider';

/**
 * Har innlogget bruker tilgang til lekeplassen hos denne stiftelsen?
 * `null` mens det sjekkes.
 *
 * `user.admin` er en billig forhåndssjekk så vanlige søkere aldri kaller
 * endepunktet; selve avgjørelsen tas av API-et.
 */
const usePlaygroundAccess = (): boolean | null => {
    const { user, sub } = useAuthContext();
    const authSub = sub || readOidcSub();
    const [access, setAccess] = useState<boolean | null>(null);

    useEffect(() => {
        if (!user) return;
        if (!user.admin || !authSub) {
            setAccess(false);
            return;
        }
        let cancelled = false;
        fetchPlaygroundAccess(authSub).then((ok) => {
            if (!cancelled) setAccess(ok);
        });
        return () => {
            cancelled = true;
        };
    }, [user, authSub]);

    return access;
};

export default usePlaygroundAccess;
